import { useOrderFormStore } from '@/modules/order/stores/order-form.store'

export const useGetParamsLayoutProductDetailsHook = () => {
  const { paramsLayoutOrderForm } = useOrderFormStore()

  const getParamsLayout = (field: string) => {
    if (paramsLayoutOrderForm) {
      return paramsLayoutOrderForm.geral.find(
        (params) => params.campo === field,
      )
    }
  }

	 const getParamsLayoutPorFielName= (field: string) => {
    if (paramsLayoutOrderForm) {
      return paramsLayoutOrderForm.geral.find(
        (params) => params.fieldName === field,
      )
    }
  }


  return {
    getParamsLayout,
		getParamsLayoutPorFielName
  }
}
